import CreateRewards from './CreateRewards/index'
export default CreateRewards
